import { useEffect, useState } from 'react';

import { BreakpointWidth } from '../shared/constants';
import { useThrottle } from './useTrottle';

interface WindowSize {
  width: number;
  height: number;
  mobileView: boolean;
}

/** Must match `theme.breakpoints.down('md')` (see styles/constants breakpointValues.md). */
//todo drop it
export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: window.innerWidth,
    height: window.innerHeight,
    mobileView: window.innerWidth < BreakpointWidth.tabletWidth,
  });

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
      mobileView: window.innerWidth < BreakpointWidth.tabletWidth,
    });
  };

  const callback = useThrottle(handleResize, 100);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', callback);
    //todo add trottle
    return () => window.removeEventListener('resize', callback);
  }, []);

  return windowSize;
};
